
import ReactDOM from 'react-dom';
import { useEffect, useState } from "react";

import {AppLink as Link, AppWrapper, MasterBlocks} from "../components/helpers";
import app from "../components/app";
import {languages} from "../components/utility";


import Editor from "./editor";



const fetchLanguage2 = async function(text, target_lang) {
    const response = await fetch("https://api-fetch.mediadirhub.com/ai-builder", {
        method:"POST",
        body:JSON.stringify({
            method:"getLanguage",
            json:JSON.stringify({
                data:text
            }),
            lang:target_lang
        })
    });    
    const data = await response.json();
    return data.data.map(function(v){
        return v;
    });
    return data;
}

export const fetchLanguage = async function(text, target_lang) {
    //return fetchLanguage2(text, target_lang);
    const response = await app.fetchPost({
        "text":text,
        "target_lang":target_lang,
        "method":"getLangConvertor"
    })
    return response.translations.map(function(v){
        if(v) {
            return v.text;
        }
        return "";
    });
}

const getLanguageBoth = async function(texts, titles, target_lang) {
    const values =  await Promise.all([fetchLanguage(texts, target_lang), fetchLanguage(titles, target_lang)]);
    return {
        texts:values[0],
        titles:values[1]
    };
}

const LandConverter = function({lang,langJson, data}) {
    const [status, setStatus] = useState(lang.status); 
    useEffect(() => {
        setStatus(lang.status)
    }, [lang]);
    const saveItem = function(item) {
        app.preloader(true);
        console.log(item.data, lang.key);
        convertBlock(item.data, lang.key).then(function(response){
            app.fetchPost({
                "method":"saveBlockLang",
                "title":item.title,
                "page":item.page,
                "master":item.master,
                "type":item.type,
                "status":true,
                "lang":lang.live,
                "reference":item.id,
                "data":JSON.stringify(response)
            }, false).then(function(response){
                setStatus(true);
                lang["id"] = response.data._id;
                app.preloader(false);
            })
        })
       
    }
    // let loader =  <div className="spinner-border text-secondary ms-auto" role="status">
    // <span className="visually-hidden">Loading...</span>
    // </div>

    const styleSvg = {
        height:"2.5em",
        position: "relative",
        left: "-2px",
        top: "-2px",
        width:"2.5em"
    }

    let loader = "";
    if(status) {
        //loader = <span className="badge bg-success ms-auto">success</span>
        loader =     <svg xmlns="http://www.w3.org/2000/svg" style={styleSvg} width="16" height="16" fill="currentColor" className="bi bi-check" viewBox="0 0 16 16">
        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"/>
        </svg>

    }
    let preview = "";
    if(status) {
        preview =  <a className="btn btn-outline-secondary btn-sm" href={`/desktop-preview/blocks/${lang.id}`}>Preview</a>
    }

    return <li className="list-group-item d-flex align-items-center block-widget" style={{height:"50px"}}>
        <div className="border border-2 border-secondary rounded me-2" style={{width:"40px", height:"40px"}}>
            {loader}
        </div>
<span>{lang.text} ({lang.live})</span>
        <div className="buttons ms-auto">
        <button className="btn btn-outline-secondary btn-sm me-2" onClick={() => saveItem(data)}>Convert</button>
        {preview}
        </div>
    </li>
}

export const convertBlock = async function(data, lang) {
    const texts = [];
    const titles = [];
    const keys = [];
    const items = [];
    const allLangs = [];

    for(var key in data.elements) {
        titles.push(data.elements[key].editorTitle?data.elements[key].editorTitle:"");
        keys.push(key);
        if(data.elements[key]["items"]) {
            data.elements[key]["items"].forEach(function(item){
                const itemValue = {
                    texts:[],
                    titles:[],
                    keys:[]
                };
                for(var k in item) {
                    if(["properties", "viewId", "viewType", "gridId"].indexOf(k) === -1) {
                        itemValue.titles.push(item[k].editorTitle);
                        itemValue.keys.push(k);
                        if(item[k]["text"]) {
                            itemValue.texts.push(item[k]["text"]);
                        }
                        else {
                            itemValue.texts.push("");
                        }
                    }
                }
                items.push(itemValue);
            })
            texts.push("");
        }
        else {
            if(data.elements[key]["text"]) {
                texts.push(data.elements[key]["text"]);
            }
            else {
                texts.push("");
            }
        }
    }
    if(data.lang) {
        for(var key in data.lang) {
            allLangs.push({
                key, value:data.lang[key]
            })
        }
        const langResponse = await fetchLanguage(allLangs.map(function(v){
            return v.value
        }), lang);
        langResponse.forEach(function(v, i){
            data.lang[allLangs[i].key] = v;
        });
        
    }
    
    
    

    const response = await getLanguageBoth(texts, titles, lang);
    const itemsResponse = await Promise.all(items.map(function(v){
        return getLanguageBoth(v.texts, v.titles, lang);
    }));

    console.log(texts, titles, keys, items);
    console.log(response, itemsResponse);
    keys.forEach(function(rootKey, i){
        if(response.texts[i] !== "") {
            data.elements[rootKey].text = response.texts[i];
        }
        data.elements[rootKey].editorTitle = response.titles[i];
        if(data.elements[rootKey].items) {
            items.forEach(function(v, i){
                v.keys.forEach(function(key, ind){
                    if(itemsResponse[i].texts[ind] !== "") {
                        data.elements[rootKey].items[i][key].text = itemsResponse[i].texts[ind];
                    }
                    data.elements[rootKey].items[i][key].editorTitle = itemsResponse[i].titles[ind];
                })
            })
        }
    });
    return data;
}

export const convertBlockOld = function(data) {

    const langItems = [];
    for(var key in data.elements) {
        const a = {
            key,
            editorTitle:data.elements[key].editorTitle
        }
        if(data.elements[key]["items"]) {
            a["items"] = data.elements[key]["items"].map(function(item){
                const nextArray = [];
                for(var k in item) {
                    if(["properties", "viewId", "viewType", "gridId"].indexOf(k) === -1) {
                        const b = {
                            key:k,
                            editorTitle:item[k].editorTitle
                        }
                        if(item[k]["text"]) {
                            b["text"] = item[k]["text"];
                        }
                        nextArray.push(b);
                    }
                }
                return nextArray;
            })
        }
        else {
            if(data.elements[key]["text"]) {
                a["text"] = data.elements[key]["text"];
            }
        }
        langItems.push(a)
    }
    console.log(langItems);
}

export default function Blocks(props) {
    const [data, setData] = useState([]);
    const [item, setItem] = useState(null);
    const [langJson, setLangJson] = useState(languages);
    useEffect(() => {
        if(props.category) {
            app.fetchPost({
                "method":"getAllBlocks",
                "id":props.category
            }).then(function(response){
                // console.log(response);
                let itemData = response.data[0];
                itemData.data = JSON.parse(itemData.data);
                const tempData = itemData.data;
                //convertBlock(tempData);
                setItem(itemData);
            })
            loadBlocks(props.category);
        }
    }, []);

    const loadBlocks = function() {
        app.fetchPost({
            "method":"getAllBlocks",
            "reference":props.category
        }).then(function(response){
            const nextJson = JSON.parse(JSON.stringify(langJson));
            response.data.forEach(function(item){
                nextJson.forEach(function(v){
                    if(v.live === item.lang) {
                        v["status"] = true;
                        v["id"] = item.id;
                        v["data"] = JSON.parse(item.data);
                    }
                })
            })
            // console.log(nextJson);
            setLangJson(nextJson);
        })
    }

    
    
    if(item) {
        return <AppWrapper>
        <div className="container blocks-container p-2">
            <ul className="list-group">
                {
                    langJson.map(function(v){
                        return <LandConverter key={v.key} lang={v} data={item} id={v.id} already={v.status}  />
                    })
                }
            </ul>
        </div>
    </AppWrapper>
    }
    return <div>Loading</div>
   
}